"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = ConfirmOutputChanges;

var _react = _interopRequireDefault(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit"),
    _constants = require("../../constants");

require("./styles/_output-changes.scss");

var OUTPUT_STATUS = {
  INTERNAL_REVIEW: "INTERNAL_REVIEW",
  PENDING_REVIEW: "PENDING_REVIEW",
  COST_REVIEW: "COST_REVIEW"
},
    getModalConstants = function getModalConstants(status) {
  return status === OUTPUT_STATUS.INTERNAL_REVIEW ? {
    title: "Reject Version",
    bodyTitle: "Reason for rejection",
    additionalReasonTitle: "Additional Comments*",
    reasons: _constants.REJECTION_REASONS.REJECT_VERSION
  } : {
    title: "Submit Changes",
    bodyTitle: "Please tell us about your changes",
    additionalReasonTitle: "Reason*",
    reasons: _constants.REJECTION_REASONS.SUBMIT_CHANGES
  };
};

function ConfirmOutputChanges(props) {
  var otherReason = props.otherReason,
      _props$selectedReason = props.selectedReasons,
      selectedReasons = void 0 === _props$selectedReason ? [] : _props$selectedReason,
      outputStatus = props.outputStatus,
      subtitle = props.subtitle,
      onCheck = props.onCheck,
      onInputChange = props.onInputChange,
      isInternalReview = outputStatus === OUTPUT_STATUS.INTERNAL_REVIEW,
      _getModalConstants = getModalConstants(outputStatus),
      title = _getModalConstants.title,
      bodyTitle = _getModalConstants.bodyTitle,
      additionalReasonTitle = _getModalConstants.additionalReasonTitle,
      reasons = _getModalConstants.reasons;

  return _react["default"].createElement("div", null, _react["default"].createElement("h3", {
    className: "output-changes__title"
  }, title), _react["default"].createElement("p", {
    className: "output-changes__subtitle"
  }, subtitle), _react["default"].createElement("p", {
    className: "output-changes__body-title"
  }, bodyTitle), _react["default"].createElement("ul", {
    className: (0, _classnames["default"])("output-changes__reasons", {
      "output-changes__reasons__columns": isInternalReview
    })
  }, reasons.map(function (reason) {
    return _react["default"].createElement("li", {
      key: reason,
      className: "output-changes__reasons__item"
    }, _react["default"].createElement(_uiKit.Checkbox, {
      checked: selectedReasons.includes(reason),
      onChange: onCheck(reason)
    }, reason));
  })), _react["default"].createElement(_uiKit.Input, {
    className: "output-changes__additional-reason",
    label: additionalReasonTitle,
    multiline: !0,
    value: otherReason,
    onChange: onInputChange,
    rows: 4
  }));
}